import React, { Component } from 'react';
import '../../../src/styles/Journals.css';
import { Link } from 'react-router-dom';


export class JournalTopics extends Component {
    displayName = JournalTopics.name
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            login: false
        }
        this.listView = this.listView.bind(this);
        this.gridView = this.gridView.bind(this);
    }
    listView = () => { //Journal main - component
        var i;
        //var elements = document.getElementsByClassName("col-lg-4");
        var element = document.getElementsByName("GridList");

        for (i = 0; i < element.length; i++) {
            element[i].classList.remove("col-lg-4");
            element[i].classList.add("col-lg-12");
            var container = document.getElementById("btnContainer");
            var btns = container.getElementsByClassName("btn");
            for (var j = 0; j < btns.length; j++) {
                btns[j].addEventListener("click", function () {
                    var current = document.getElementsByClassName(" activeClick");
                    current[0].className = current[0].className.replace(" activeClick", "");
                    this.className += " activeClick";
                });

            }
        }
        var Borderelements = document.getElementsByClassName("Border");

        for (var k = 0; k < Borderelements.length; k++) {
            Borderelements[k].style.padding = "1% 0% 0% 1%";

        }

        var Imgelements = document.getElementsByClassName("JounrnalImg");

        for (var l = 0; l < Imgelements.length; l++) {
            Imgelements[l].style.height = "104px";

        }


    }
    gridView = () => {

        //var elements = document.getElementsByClassName("col-lg-4");
        var element = document.getElementsByName("GridList");
        // Declare a loop variable
        var i;
        for (i = 0; i < element.length; i++) {
            element[i].classList.remove("col-lg-12");
            element[i].classList.add("col-lg-4");
            //elements[i].style.width = "33%";
            var container = document.getElementById("btnContainer");
            var btns = container.getElementsByClassName("btn");
            for (var k = 0; k < btns.length; k++) {
                btns[k].addEventListener("click", function () {
                    var current = document.getElementsByClassName(" activeClick");
                    current[0].className = current[0].className.replace(" activeClick", "");
                    this.className += " activeClick";
                });
            }
        }

        var Borderelements = document.getElementsByClassName("Border");

        for (var j = 0; j < Borderelements.length; j++) {
            Borderelements[j].style.padding = "3% 0% 3% 3%";

        }

        var Imgelements = document.getElementsByClassName("JounrnalImg");

        for (var l = 0; l < Imgelements.length; l++) {
            Imgelements[l].style.height = "150px";

        }

        /* Optional: Add active class to the current button (highlight it) */
    }

    render() {
        //console.log(this.state.login)
        return (
            <div>
                <div className="col-12">

                    <div className="row">
                        <div className="col-lg-9">
                            <p className="colPadding Title"> Journals</p>
                            <p className="colPadding BookBody"> Kluwer Law Online publishes peer-reviewed journals on international legal matters in areas such as European
                        community law, arbitration, corporate, commerical and trade law.</p>
                        </div>
                    </div>

                    <div className="row margintop">
                        <div className="col-lg-5 colPadding">
                            <input className="form-control" id="ex3" type="text" placeholder="Refine list by words in title" />
                        </div>
                        <div className="col-lg-3 colPadding">

                        </div>
                        <div className="col-lg-2 text-center colJournal-sm-2">
                            <div className="dropdown">
                                <button className="dropbtn"><strong className="Fleft">PRACTICE AREA</strong> <i className="fa fa-caret-down"></i></button>
                                <div className="dropdown-content">
                                    <a href="/Journals"><strong className="Fleft">A-Z</strong> </a>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-2 text-center">
                            <div id="btnContainer" className="btn-group">
                                <button className="btn btn-fa activeClick" onClick={this.gridView} style={{ color: 'darkgrey' }}><i className="fa fa-th"></i></button>
                                <button className="btn btn-fa" onClick={this.listView} style={{ color: 'darkgrey' }}><i className="fa fa-bars"></i></button>
                            </div>
                        </div>
                    </div>
                    {this.state.login ?
                        <div className="row" id="LoginJournal">
                            <div className="col-lg-12 colPadding">  <hr></hr> </div>
                        </div> : null
                    }
                    {this.state.login ?
                        <div className="row" id="LoginJournalhdr">
                            <div className="col-lg-9">
                                <h3 className="LawHeader colPadding">Your subscriptions</h3>
                            </div>
                        </div>
                        : null
                    }
                    <br>
                    </br>
                    <div className="col-12">
                        <div className="BGGrey">
                            <div className="row rowmrg">

                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics">
                                            <h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Arbitration </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication"> <img alt="" src="/../../images/books/common-market-law.png" className="JounrnalImg" /></Link>
                                            <div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/Journals" style={{ lineHeight: '0px' }}>Air and Space Law</Link></h4>
                                                <p className="paddingL journalbody">
                                                    Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                 <br></br>
                                                    <br></br>
                                                    <a href="/" className="LinkClass">Latest Issue </a></p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Banking/Finance </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/Journals">  <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/Journals" style={{ lineHeight: '0px' }}>BCDR International Arbitration  </Link></h4>  <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                           <br></br> <br></br> <a href="/" className="LinkClass">Latest Issue </a></p>
                                            </div></div>

                                    </div>

                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Banking/Finance </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/CivilPro.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Belgian Review of Arbitration </Link></h4><p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                               <br></br> <br></br> <a href="/" className="LinkClass">Latest Issue </a></p></div>

                                        </div>

                                    </div>


                                </div>
                            </div>

                            <div className="row rowmrg">

                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics">
                                            <h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Banking/Finance </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication"> <img alt="" src="/../../images/books/common-market-law.png" className="JounrnalImg" /></Link>
                                            <div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Business Law Review</Link></h4>
                                                <p className="paddingL journalbody">
                                                    Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                 <br></br>
                                                    <br></br>
                                                    <a href="/" className="LinkClass">Latest Issue </a></p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />  Comparative law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Air And Space Law  </Link></h4>  <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                           <br></br> <br></br> <a href="/" className="LinkClass">Latest Issue </a></p>
                                            </div></div>

                                    </div>

                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />  Comparative law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/CivilPro.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>European Company Law </Link></h4>  <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                           <br></br> <br></br> <a href="/" className="LinkClass">Latest Issue </a></p>
                                            </div></div>

                                    </div>


                                </div>
                            </div>

                            <div className="row rowmrg">

                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Competition Law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">   <img alt="" src="/../../images/books/common-market-law.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>EC Tax Review </Link></h4><p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                <br></br> <br></br>  <a href="/" className="LinkClass">Latest Issue </a></p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />Corporate/Commercial law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>European Company Law</Link></h4>   <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                  <br></br> <br></br>   <a href="/" className="LinkClass">Latest Issue </a></p> </div>
                                        </div>

                                    </div>


                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />European Union law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/CivilPro.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Environmental Law Review </Link></h4> <p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                 <br></br> <br></br>  <a href="/" className="LinkClass">Latest Issue </a></p> </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="row rowmrg">

                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />Energy / Environmental law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/common-market-law.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Journal of European Market Law </Link></h4> <p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                 <br></br> <br></br>  <a href="/" className="LinkClass">Latest Issue </a></p>   </div>

                                        </div>

                                    </div>

                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />Intellectual/Property law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication"> <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Journal of European Market Law </Link></h4>
                                                <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                              <br></br> <br></br><a href="/" className="LinkClass">Latest Issue </a></p>  </div>
                                        </div>

                                    </div>


                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Taxation </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication"> <img alt="" src="/../../images/books/CivilPro.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Journal of European Market Law </Link></h4> <p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                <br></br> <br></br> <a href="/" className="LinkClass">Latest Issue </a></p></div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className="row rowmrg">

                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Trade law  </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/common-market-law.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Journal of World Trade </Link></h4> <p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                 <br></br> <br></br>  <a href="/" className="LinkClass">Latest Issue </a></p></div>
                                        </div>


                                    </div>

                                </div>
                                <div name="GridList" className="col-lg-4 Gridcolumn">
                                    <div className="Border">
                                        <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />Transport law </h5> </Link>
                                        <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                            <Link to="/JournalPublication">  <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Revista Brasileira de Arbitragem </Link></h4>  <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                 <br></br> <br></br>    <a href="/" className="LinkClass">Latest Issue </a></p></div>
                                        </div>


                                    </div>
                                </div>

                            </div>

                        </div>
                        {this.state.login ?
                            <div className="row" id="LoginAvailableJournal">
                                <h3 className="LawHeader">Other available journals</h3>
                            </div>
                            : null
                        }
                        {this.state.login ?
                            <div className="BGGrey" id="LoginJournalgrid">
                                <div className="row rowmrg">

                                    <div name="GridList" className="col-lg-4 Gridcolumn">
                                        <div className="Border">
                                            <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Arbitration </h5> </Link>
                                            <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                                <Link to="/JournalPublication">  <img alt="" src="/../../images/books/common-market-law.png" className="JounrnalImg" /></Link> <div>
                                                    <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Air and Space Law</Link></h4>
                                                    <p className="paddingL journalbody">
                                                        Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                              <br></br> <br></br><a href="/" className="LinkClass">Latest Issue </a></p>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div name="GridList" className="col-lg-4 Gridcolumn">
                                        <div className="Border">
                                            <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Banking/Finance </h5> </Link>
                                            <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                                <Link to="/JournalPublication"> <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                    <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>BCDR International Arbitration  </Link></h4>  <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                              <br></br> <br></br><a href="/" className="LinkClass">Latest Issue </a></p>
                                                </div></div>

                                        </div>

                                    </div>
                                    <div name="GridList" className="col-lg-4 Gridcolumn">
                                        <div className="Border">
                                            <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Banking/Finance </h5> </Link>
                                            <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                                <Link to="/JournalPublication"> <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                    <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>BCDR International Arbitration  </Link></h4>  <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                              <br></br> <br></br><a href="/" className="LinkClass">Latest Issue </a></p>
                                                </div></div>

                                        </div>

                                    </div>
                                    <div name="GridList" className="col-lg-4 Gridcolumn">
                                        <div className="Border">
                                            <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Comparative law </h5> </Link>
                                            <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                                <Link to="/JournalPublication">  <img alt="" src="/../../images/books/CivilPro.png" className="JounrnalImg" /></Link><div>
                                                    <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>Business Law Review </Link></h4><p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                 <br></br> <br></br>  <a href="/" className="LinkClass">Latest Issue </a></p></div>

                                            </div>

                                        </div>


                                    </div>
                                </div>
                                <div className="row rowmrg">

                                    <div name="GridList" className="col-lg-4 Gridcolumn">
                                        <div className="Border">
                                            <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" /> Competition Law </h5> </Link>
                                            <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                                <Link to="/JournalPublication"> <img alt="" src="/../../images/books/common-market-law.png" className="JounrnalImg" /></Link><div>
                                                    <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>EC Tax Review </Link></h4><p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                  <br></br> <br></br>   <a href="/" className="LinkClass">Latest Issue </a></p>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div name="GridList" className="col-lg-4 Gridcolumn">
                                        <div className="Border">
                                            <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />Corporate/Commercial law </h5> </Link>
                                            <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                                <Link to="/JournalPublication">   <img alt="" src="/../../images/books/JournalOfWorldTrade.png" className="JounrnalImg" /></Link><div>
                                                    <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>European Company Law</Link></h4>   <p className="paddingL journalbody">Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                  <br></br> <br></br>  <a href="/" className="LinkClass">Latest Issue </a></p> </div>
                                            </div>

                                        </div>


                                    </div>
                                    <div name="GridList" className="col-lg-4 Gridcolumn">
                                        <div className="Border">
                                            <Link to="/Topics"><h5 className="Heading"><img alt="" src="/../../images/green-arrow.png" />European Union law </h5> </Link>
                                            <div className="JournalFlex" style={{ paddingRight: '3%' }}>
                                                <Link to="/JournalPublication">   <img alt="" src="/../../images/books/CivilPro.png" className="JounrnalImg" /></Link><div>
                                                    <h4 className="paddingL JournalTitle"> <Link to="/JournalPublication" style={{ lineHeight: '0px' }}>European Energy and Environmental Law Review </Link></h4> <p className="paddingL journalbody"> Aims to provide a forum for practitioners and scholars who are dealing with the international legal aspects of air and space law and f…
                                                <br></br> <br></br>  <a href="/" className="LinkClass">Latest Issue </a></p> </div>
                                            </div>

                                        </div>


                                    </div>
                                </div>
                            </div>
                            : null}
                    </div>
                    <div className="White">
                    </div>
                </div>
            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Journals/JournalTopics.jsx